import { useState } from 'react';

import { Footer } from '@/components/Footer';
import { Navbar } from '@/components/Navbar';
import { ReportFilters } from '@/components/ReportFilters';
import { ReportsTable } from '@/components/ReportsTable';
import { type ReportFilters as Filters, useReports } from '@/hooks/useReports';

export default function Reports() {
  const [filters, setFilters] = useState<Filters>({});

  const { reports, isLoading, fetchNextPage, hasMore, isFetchingNextPage } =
    useReports(filters);

  return (
    <div className="flex min-h-screen flex-col bg-neutral-50 text-neutral-800">
      <Navbar />

      <main className="mx-auto w-full max-w-5xl flex-1 px-4 pb-8 pt-28 sm:px-6 lg:px-8">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-neutral-900">
            Raportări BVB
          </h1>
          <p className="mt-1 text-sm text-neutral-500">
            Raportări curente publicate de companiile listate la BVB.
          </p>
        </div>

        <ReportFilters filters={filters} onFilterChange={setFilters} />

        <ReportsTable
          reports={reports}
          isLoading={isLoading}
          onLoadMore={fetchNextPage}
          hasMore={hasMore}
          isFetchingNextPage={isFetchingNextPage}
        />
      </main>

      <Footer />
    </div>
  );
}
